// @flow
import { attemptLoadTranslations, loadTranslations } from './actions';
import { call, put, takeLatest } from 'redux-saga/effects';
import { DEFAULT_LOCALE, NUMBER_OF_ATTEMPTS } from './constants';
import { delay } from 'redux-saga';

import { addLocaleData } from 'react-intl';
import { appLoaded } from '~/core/state/application/actions';
import handleSaga from '~/core/state/handle-saga';
import type { Effect } from 'redux-saga';
import type { LoadTranslationsAction } from './types';
import { memoize, noop } from 'lodash/fp';

export const loadLocaleTranslationsMemo = memoize(loadLocaleTranslations);

export function loadLocaleTranslations(locale: string) {
    const lang = locale.toLowerCase().replace(/^(\w*)-.*/i, '$1');

    return Promise.all([
        import(// Request the translations we have for this locale
        `../../i18n/translations/${locale.toLowerCase()}`),
        import(`react-intl/locale-data/${lang}`)
    ]);
}

export function* loadTranslationsSaga({ payload: { locale } }: LoadTranslationsAction): Generator<Effect | noop, *, *> {
    if (!locale || locale.toLowerCase() === DEFAULT_LOCALE.toLowerCase()) {
        return yield put(loadTranslations());
    }

    yield put(attemptLoadTranslations());

    let loadTranslationsEffect;
    for (let i = 0; i < NUMBER_OF_ATTEMPTS; i++) {
        try {
            const [translations, languagePack] = yield call(loadLocaleTranslationsMemo, locale);

            // Adding locales to `react-intl` is an idempotent operation so we don't
            // need to be concerned with possibly adding duplicates
            yield call(addLocaleData, languagePack);

            loadTranslationsEffect = put(loadTranslations(translations));

            break;
        } catch (err) {
            if (i < NUMBER_OF_ATTEMPTS - 1) {
                yield call(delay, 2000);
            } else {
                loadTranslationsEffect = put(loadTranslations(err));
            }
        }
    }
    yield loadTranslationsEffect;
}

function* watchAppLoadedSaga(): Generator<Effect, *, *> {
    yield takeLatest(appLoaded, handleSaga(loadTranslationsSaga));
}

export default [watchAppLoadedSaga];



// WEBPACK FOOTER //
// ./src/core/state/translations/sagas.js